import React from "react"
import { useAuthentication } from "@src/auth"
import * as Icon from "react-bootstrap-icons"
import { Spinner, Nav } from "react-bootstrap"
import { Link } from "react-router-dom"
import { colors } from "@src/constants"

export const LoginLogoutButton: React.FC = () => {
  const { isAuthenticated, loading, logout } = useAuthentication()
  if (!isAuthenticated) return null
  return (
    <Nav.Link as={Link} className="logoutbtn" onClick={logout} to="" eventKey="">
      {loading ? (
        <Spinner animation="border" size="sm" variant="light" />
      ) : (
        <Icon.BoxArrowRight color={colors.white} size={18} fontWeight="bold" />
      )}
    </Nav.Link>
  )
}
